module.exports = __webpack_public_path__ + "img/ugent-logo-nl.9ca8bf48.svg";